/* eslint-disable import/named */
import axios from 'axios';
import { v4 } from 'uuid';
import { CB_INTERNAL_API_URL } from '../../constants';
import { addLoadingList, removeLoadingList } from '../../reducers/notification';
import { getHeaders } from './utils/getHeaders';

const base = CB_INTERNAL_API_URL || 'https://clientbook-api-dev.clbk.app';
const version = '/api/v1';
const baseURL = `${base}${version}`;

export default class ClientbookApi {
  constructor() {
    this.serviceClient = axios.create({
      baseURL,
    });
  }

  updateClientbookApiHeaders({ merchantId, associateId, token }) {
    if (merchantId) {
      this.serviceClient.defaults.headers.common['x-clientbook-merchant-id'] = merchantId;
    }
    if (associateId) {
      this.serviceClient.defaults.headers.common['x-clientbook-associate-id'] = associateId;
    }
    if (token) {
      this.serviceClient.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
  }

  async get({ url, query, loading = false, axiosConfig = {} }) {
    const uuid = v4();
    const headers = getHeaders();
    if (loading) {
      addLoadingList(uuid);
    }
    try {
      const response = await this.serviceClient.get(url, {
        params: query,
        ...axiosConfig,
        headers: {
          ...headers,
          ...axiosConfig.headers,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${url}:`, error);
      throw error;
    } finally {
      if (loading) {
        removeLoadingList(uuid);
      }
    }
  }

  async post({ url, data, query, loading = false, axiosConfig = {} }) {
    const uuid = v4();
    const headers = getHeaders();
    if (loading) {
      addLoadingList(uuid);
    }
    try {
      const response = await this.serviceClient.post(url, data, {
        params: query,
        ...axiosConfig,
        headers: {
          ...headers,
          ...axiosConfig.headers,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error posting to ${url}:`, error);
      throw error;
    } finally {
      if (loading) {
        removeLoadingList(uuid);
      }
    }
  }

  async put({ url, data, query, loading = false, axiosConfig = {} }) {
    const uuid = v4();
    const headers = getHeaders();
    if (loading) {
      addLoadingList(uuid);
    }
    try {
      const response = await this.serviceClient.put(url, data, {
        params: query,
        ...axiosConfig,
        headers: {
          ...headers,
          ...axiosConfig.headers,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error putting to ${url}:`, error);
      throw error;
    } finally {
      if (loading) {
        removeLoadingList(uuid);
      }
    }
  }

  async patch({ url, data, query, loading = false, axiosConfig = {} }) {
    const uuid = v4();
    const headers = getHeaders();
    if (loading) {
      addLoadingList(uuid);
    }
    try {
      const response = await this.serviceClient.patch(url, data, {
        params: query,
        ...axiosConfig,
        headers: {
          ...headers,
          ...axiosConfig.headers,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error patching ${url}:`, error);
      throw error;
    } finally {
      if (loading) {
        removeLoadingList(uuid);
      }
    }
  }

  async delete({ url, query, loading = false, axiosConfig = {} }) {
    const uuid = v4();
    const headers = getHeaders();
    if (loading) {
      addLoadingList(uuid);
    }
    try {
      const response = await this.serviceClient.delete(url, {
        params: query,
        ...axiosConfig,
        headers: {
          ...headers,
          ...axiosConfig.headers,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting ${url}:`, error);
      throw error;
    } finally {
      if (loading) {
        removeLoadingList(uuid);
      }
    }
  }
}

export const clientbookApi = new ClientbookApi();
